import { render, staticRenderFns } from "./editorfull.vue?vue&type=template&id=5bbd9bca&"
import script from "./editorfull.vue?vue&type=script&lang=js&"
export * from "./editorfull.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports